var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ToggleButton',{staticClass:"mb-0",attrs:{"value":_vm.field.filter.value == 1,"type-bold":"true"},on:{"input":function($event){return _vm.$emit('input', $event == true ? 1 : 0)}}})}
var staticRenderFns = []

export { render, staticRenderFns }